module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    attrs: {
      "keep-alive": "",
      "transition-mode": "out-in"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b7766e38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 161
// module chunks = 2